@if (safeSchemaScript()) {
  <div [innerHTML]="safeSchemaScript()"></div>
}
